{
  "currentFenceDevice": {
    "arguments": {},
    "argumentsToolbar": {
      "edit": {}
    },
    "id": {},
    "meta": {
      "pair": {
        "menu": {
          "edit": {},
          "remove": {}
        },
        "name": {},
        "value": {}
      },
      "toolbar": {
        "create": {}
      },
      "noCapabilityWarning": {}
    },
    "tabs": {
      "arguments": {},
      "detail": {},
      "meta": {}
    },
    "toolbar": {
      "disable": {},
      "enable": {},
      "refresh": {},
      "dropdown": {
        "cleanup": {},
        "delete": {}
      }
    }
  },
  "empty": {},
  "list": {
    "item": {
      "id": {},
      "status": {},
      "type": {}
    }
  },
  "stopped": {}
}
